module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00001-fs8.3dbd116.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00001-fs8.png
// module id = 155
// module chunks = 0